import { render, staticRenderFns } from "./ModifyKeyword.vue?vue&type=template&id=6d0eb756"
import script from "./ModifyKeyword.vue?vue&type=script&lang=js"
export * from "./ModifyKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports